import L from 'leaflet';
import PropTypes from 'prop-types';
import { path } from 'ramda';
import React, { Component } from 'react';
import { LayerGroup, FeatureGroup, Popup, GeoJSON } from 'react-leaflet';
import { connect } from 'react-redux';
import { readEndpoint } from 'redux-json-api';

const geojsonMarkerOptions = {
  radius: 3,
  fillColor: "#000000",
  color: "#000000",
  weight: 1,
  opacity: 1,
  fillOpacity: 0.8
};

class Stops extends Component {
  static propTypes = {
    readEndpoint: PropTypes.func.isRequired,
    stops: PropTypes.array.isRequired
  };

  render () {
    const stops = this.props.stops || [];

    if (stops.length === 0) return null;

    return (
      <LayerGroup>
        {stops.map(stop => {
          if (!stop.attributes.name.match(/^Zone/g)) {
            let geojson = path(['attributes', 'geojson'], stop);

            if (typeof geojson === 'string') {
              geojson = JSON.parse(geojson);
            }

            return (
              <FeatureGroup key={stop.id}>
                <Popup>
                  <span>{stop.attributes.name}</span>
                </Popup>
                <GeoJSON
                  data={geojson}
                  pointToLayer={(feature, latlng) => {
                    return L.circleMarker(latlng, geojsonMarkerOptions);
                  }}
                />
              </FeatureGroup>
            );
          } else {
            return null;
          }
        })}
      </LayerGroup>
    );
  }
}

const mapStateToProps = (state) => ({
  stops: path(['api', 'stop', 'data'], state) || [],
});

const mapDispatchToProps = {
  readEndpoint,
};

export default connect(mapStateToProps, mapDispatchToProps)(Stops);
